
import axios from 'axios';
import Fuse from 'fuse.js';

import React, { Component}  from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import ClearIcon from '@material-ui/icons/Clear';
import LinkIcon from '@material-ui/icons/Link';
import FormHelperText from '@material-ui/core/FormHelperText';
import Chip from '@material-ui/core/Chip';

import styled from 'styled-components';
import moment from 'moment';

import Colors from 'ui/Colors';
import { Grid } from 'ui/Grid';
import { DateTimeDisplay } from 'core/Display';
import ScheduleTableSelectItems from '../Parts/ScheduleTableSelectItems';
import SearchWidget from 'form/SearchWidget';

const StyledDialogContent = styled(DialogContent)`
  padding: 0;
  
  .search {
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
  
  .errors {
    padding: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    font-size: 14px;
  }
`;

const StyledDialog = styled(Dialog)`
  .MuiDialog-container {
    align-items: flex-start;
  }
`;

const StyledDialogTitle = styled(DialogTitle)`
  .dates {
    font-weight: 500;
    font-size: 16px;
    color: ${Colors.Gray1};
  }
`;


export default class ScheduleForm extends Component {

  static defaultProps = {
    showRemoveScheduleButton: true,
    confirmationRequired: true
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      loading: false,
      items: [],
      searchPhrase: '',
      selectedSchedule: undefined
    };
  }

  searchItems = (items, phrase) => {
    if (!phrase)
      return items;

    const options = {
      includeScore: true,
      threshold: 0.3,
      shouldSort: false,
      keys: [
        'start_slot.semi_trailer.label',
        'start_slot.semi_trailer.number',
        'start_slot.driver.full_name',
        'start_slot.tractor_unit.label',
        'start_slot.tractor_unit.number',
        'start_slot.comment',
      ]
    };

    const fuse = new Fuse(items, options);
    let results = [];
    fuse.search(phrase).forEach(el => results.push(el.item));
    return results;
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
      items: [],
      selectedSchedule: undefined
    })
  };

  handleOpen = () => {
    const { context } = this.props;
    const item = context.item;

    this.setState({
      loading: true,
      isOpen: true
    });

    let params = {
      date_start: moment(item.date_start).format('YYYY-MM-DD'),
      time_start: moment(item.date_start).format('HH:mm')
    };

    if (item.date_end) {
      params['date_end'] =  moment(item.date_end).format('YYYY-MM-DD');
      params['time_end'] =  moment(item.date_end).format('HH:mm');
    }

    if (item.cargo_weight && parseInt(item.cargo_weight)) {
      params['cargo_weight'] = parseInt(item.cargo_weight);
    }

    axios.get('timetable_slot/search', {params: params}).then(res => {
      this.setState({
        loading: false,
        items: res.data
      })
    })
  };

  onSelect = (item) => {
    const { confirmationRequired } = this.props;
    this.setState({
      selectedSchedule: item.start_slot
    });
    if (confirmationRequired === false) {
      this.handleChange(item.start_slot);
    }
  };

  getSearchWords = (searchPhrase) => {
    if (searchPhrase) {
      return searchPhrase.split(' ');
    }
    return [];
  };

  handleChange = (schedule) => {
    const { onChange } = this.props;
    onChange(schedule, this.handleClose);
  }

  render() {
    const { context, showRemoveScheduleButton } = this.props;
    const { isOpen, loading, items, searchPhrase, selectedSchedule } = this.state;
    const item = context.item;
    const schedule = item.schedule;

    if (!item.date_start)
      return <React.Fragment />;

    const searchedItems = this.searchItems(items, searchPhrase);

    return (
      <div className={'mb-20'}>

        <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
          <Button
            variant={'outlined'}
            onClick={() => this.handleOpen()}
            color={'primary'}
            size={'large'}
            fullWidth={true}
            startIcon={<LinkIcon />}
          >
            {schedule ? 'Изменить связку' : 'Выбрать связку'}
          </Button>

          {(schedule && showRemoveScheduleButton) && (
            <Button
              variant={'outlined'}
              onClick={() => this.handleChange(null)}
              color={'secondary'}
              size={'large'}
              fullWidth={true}
              startIcon={<ClearIcon />}
            >
              Убрать связку
            </Button>
          )}
        </Grid>

        {context.errors.schedule && (
          <FormHelperText error={true}>{context.errors.schedule}</FormHelperText>
        )}

        <StyledDialog
          open={isOpen}
          onClose={() => this.handleClose()}
          scroll={'paper'}
          fullWidth={true}
          maxWidth={'lg'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <StyledDialogTitle>
            Доступные связки
            <span className={'dates ml-20'}>
              <Chip
                label={<DateTimeDisplay value={item.date_start} />}
                color="primary"
              />
              {item.date_end && (
                <React.Fragment>
                  {' → '}
                  <Chip
                    label={<DateTimeDisplay value={item.date_end} />}
                    color="primary"
                  />
                </React.Fragment>
              )}
              {item.cargo_weight && (
                <Chip label={`ВЕС ГРУЗА: ${item.cargo_weight} кг`} className={'ml-10'} />
              )}
            </span>
          </StyledDialogTitle>
          <StyledDialogContent dividers={true}>
            <div className={'search'}>
              <SearchWidget
                value={searchPhrase}
                onChange={(value) => this.setState({'searchPhrase': value})}
                fullWidth={true}
                autoFocus={true}
              />
            </div>

            {context.errors.schedule && (
              <div className={'errors'}>
                <FormHelperText error={true}>{context.errors.schedule}</FormHelperText>
              </div>
            )}

            <ScheduleTableSelectItems
              loading={loading}
              items={searchedItems}
              onSelect={(item) => this.onSelect(item)}
              searchWords={this.getSearchWords(searchPhrase)}
              selected={selectedSchedule}
            />
          </StyledDialogContent>

          {selectedSchedule && (
            <DialogActions>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleChange(selectedSchedule)}
              >
                Изменить связку
              </Button>
            </DialogActions>
          )}
        </StyledDialog>

      </div>
    )
  }
}
